import {useMutation, useQueryClient} from '@tanstack/react-query'

import {driverJobKeys} from 'src/driver-view/query-keys'

import {deployStockEquipment} from './api'
import type {DeployStockEquipmentInput} from './schemas'

export function useDeployStockEquipment(jobId: string, accessToken: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: DeployStockEquipmentInput) =>
            deployStockEquipment(jobId, accessToken, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: driverJobKeys.detail(jobId, accessToken),
            })
        },
    })
}
